import React from 'react';
import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles({
  root: {
    display: "flex",
    flexDirection: "column",
  },
  link: {
    width:"fit-content",
    color: "rgba(0,0,0,0.87)",
    "&:visited": {
      color: "rgba(0,0,0,0.87)"
    },
    "&:hover": {
      color: "rgba(0,0,0,0.52)"
    }
  },
  order:{
    fontFamily:"monospace"
  },
  indent:{
    paddingLeft:"1rem",
  },
});

function HelpSectionTOC(props) {
  const { section, onlyChildren=false, recursive=false } = props;
  const classes = useStyles();
  const hasSections = Object.keys(section.sections||[]).length > 0;
  const order = section.fullOrder.endsWith("0.0") ? section.fullOrder.substring(0, section.fullOrder.length - 4) : section.fullOrder;
  const link = <a className={classes.link} href={`#help_${section.fullOrder}`}><span className={classes.order}>{order}</span> - {section.title}</a>;

  return !onlyChildren ? !recursive ? link
    : <div className={classes.root}>
        {link}
        {!hasSections ? null :
          <div className={classes.indent} >
            {Object.entries(section.sections || []).map(([k, v]) => {
              return <HelpSectionTOC key={k} section={v} recursive={recursive} onlyChildren={false} />;
            })}
          </div>
        }
      </div>
    : <div className={classes.root}>
        {!hasSections ? null :
          Object.entries(section.sections || []).map(([k, v]) => {
            return <HelpSectionTOC key={k} section={v} recursive={recursive} onlyChildren={false} />;
          })
        }
      </div>;
}

export default HelpSectionTOC;
